import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import { AbLink, AbDescription } from '../../../ui';
import UiButton from '../../../canyon/ui/UiButton.vue';

interface Props {
  image?: string;
  alt?: string;
  title?: string;
  date?: string;
  url?: string;
  download?: boolean;
  downloadText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionTextImageCard',
  props: {
    image: null,
    alt: null,
    title: null,
    date: null,
    url: null,
    download: { type: Boolean },
    downloadText: null
  },
  setup(__props: any) {



return { __sfc: true,CdnImg, AbLink, AbDescription, UiButton }
}

})